export default "/fonts/UkNumberPlate.woff?3f817bec335951eb24234ce27d77808d";